module.exports = __webpack_public_path__ + "img/renke-5.9ad3d277.png";